/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, PLATFORM_ID, effect, inject, input } from '@angular/core';
import { SwiperOptions } from 'swiper/types';

import { MovieLoadingComponent, MovieDetailSkeletonComponent } from '@usheru-hff/ui/movie-detail-page';
import { UiMovieLaurelComponent } from '@usheru-hff/movie-detail/ui-movie-laurel';
import { Movie, MovieLaurel } from '@usheru-hff/shared/domain';
import { SwiperDirective } from '@usheru-hff/shared/ui-swiper';

@Component({
  selector: 'ush-feature-laurels-carousel',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, SwiperDirective, UiMovieLaurelComponent, MovieDetailSkeletonComponent],
  templateUrl: './feature-laurels-carousel.component.html',
  styleUrls: ['./feature-laurels-carousel.component.scss']
})
export class FeatureLaurelsCarouselComponent implements MovieLoadingComponent {
  protected readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  readonly laurels = input<MovieLaurel[] | null>(null);
  readonly fitBase = input<number>(1);
  readonly fitMd = input<number>(2);
  readonly fitLg = input<number>(4);
  readonly fitXl = input<number>(6);
  readonly isLoadingData = input(false);

  swiperConfig: SwiperOptions = this.buildSwiperConfig(0);

  constructor() {
    effect(() => {
      this.swiperConfig = this.buildSwiperConfig(this.laurels()?.length ?? 0);
    });
  }

  private buildSwiperConfig(totalLaurels: number): SwiperOptions {
    const available = Math.max(totalLaurels, 1);
    const fit = (desired: number): number => Math.min(desired, available);

    return {
      slidesPerView: fit(this.fitBase()),
      spaceBetween: 10,
      lazyPreloaderClass: undefined,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      watchOverflow: true,
      breakpoints: {
        768: {
          slidesPerView: fit(this.fitMd()),
          spaceBetween: 16
        },
        992: {
          slidesPerView: fit(this.fitLg()),
          spaceBetween: 24
        },
        1400: {
          slidesPerView: fit(this.fitXl()),
          spaceBetween: 30
        }
      }
    };
  }
}
